import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M10.9998 3.001V18.789L5.98978 13.468C5.61178 13.066 4.97878 13.047 4.57578 13.426C4.17478 13.804 4.15578 14.437 4.53378 14.84L10.7738 21.468C11.0808 21.792 11.5038 21.983 11.9438 21.999C11.9628 22 11.9808 22 11.9998 22C12.0188 22 12.0388 22 12.0578 21.999C12.4968 21.983 12.9198 21.791 13.2248 21.467L19.4648 14.839C19.6468 14.646 19.7358 14.4 19.7358 14.153C19.7358 13.887 19.6308 13.622 19.4218 13.425C19.0198 13.047 18.3868 13.066 18.0078 13.467L12.9998 18.787L12.9998 3C12.9998 2.447 12.5518 2 11.9998 2C11.4478 2 10.9998 2.448 10.9998 3.001Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ArrowDownward');

export default Icon;
